import React from "react";
import PropTypes from "prop-types";
import { Wrapper, BackgroundContainer } from "./styles";

import { useSelector } from "react-redux";

export default function DefaultLayout({ children }) {
	const stateCheck = useSelector((state) => state.sessionStorage.state);
	return (
		<div>
			{["LOGIN", "NO_STATE"].includes(String(stateCheck).toLocaleUpperCase()) ? (
				<div>
					<BackgroundContainer></BackgroundContainer>
				</div>
			) : null}
			<Wrapper>{children}</Wrapper>
		</div>
	);
}

DefaultLayout.prototype = {
	children: PropTypes.element.isRequired,
};
